import createAction from 'redux-actions/lib/createAction';

export const GRID_COLUMNS = 'headerActions/GRID_COLUMNS';
export const gridColumns = createAction(GRID_COLUMNS);
